<template></template>
<script>  
    export default {
        mounted(){
            this.$emit('iconmsg');
        }
    }
</script>